<template>
<div id="admin-panel" class="container">
  <div class="admin-panel">
    <div class="admin-top-bar">
      <h1>RAFIKI<span style="font-weight:100">LITE</span></h1>    
      <button type="button" id="logout-btn" class="btn" @click="logOut()"><logout-icon :size="36"></logout-icon> </button>
    </div>

    <template v-if="!editingProject && settingsLoaded && projectsLoaded">
      <h2>Settings</h2>
      <settings-form :settings="siteSettings"></settings-form>
      <h2>Projects</h2>
      <div class="projects-list row center-xs">
        <div class="projects-list-item col-xs-12 col-sm-6" v-for="project in projects" v-bind:key="project._id">
          <p>{{ project.title }}</p>
          <div class="projects-list-item-actions">
            <pencil-icon class="edit-icon" :size="36" @click="editProject(project)"></pencil-icon>
            <delete-icon class="delete-icon" :size="36" @click="deleteProject(project._id)"></delete-icon>
          </div>
        </div>
      </div>
    </template>

    <template v-if="editingProject">
      <h2><span v-if="selectedProject._id">EDITING PROJECT</span><span v-else>NEW PROJECT</span></h2>
      <project-form :project="selectedProject"></project-form>
    </template>

    <div class="fab" @click="newProject()">
      <span class="fab-action-button">
          <plus-icon :size="48" v-if="!editingProject"></plus-icon>
          <close-icon :size="48" v-else></close-icon>
        </span>
    </div>
  </div>
</div>
</template>

<script>
import { UserService, ProjectsService, LoggingService, SettingsService } from "@/services/ApiService.js";
import ProjectForm from "@/components/ProjectForm";
import SettingsForm from "@/components/SettingsForm";
import { EventBus } from '@/services/EventBus.js';
import PlusIcon from 'vue-material-design-icons/Plus.vue';
import CloseIcon from 'vue-material-design-icons/Close.vue';
import DeleteIcon from 'vue-material-design-icons/Delete.vue';
import PencilIcon from 'vue-material-design-icons/Pencil.vue';
import LogoutIcon from 'vue-material-design-icons/Logout.vue';

export default {
    name: 'Admin',
    components: {
      ProjectForm,
      SettingsForm,
      PlusIcon,
      CloseIcon,
      DeleteIcon,
      PencilIcon,
      LogoutIcon
    },
    data() {
      return {
        projects: [],
        editingProject: false,
        selectedProject: {
          title: '',
          year: '',
          description: '',
          cover: '',
          photoCredit: '',
          images: []          
        },
        siteSettings: {
          bannerUrl: ""
        },
        settingsLoaded: false, 
        projectsLoaded: false
      }   
    },
    methods: {
      logOut() {
        UserService.logOut();
        this.$router.push('/')
      },
      loadSettings() {
        SettingsService.get().then((res) => {
          this.siteSettings = res.data[0];
          this.settingsLoaded = true;
        }).catch((err) => {
          LoggingService.log("Admin", "Error loading SiteSettings", err);
        });
      },
      loadProjects() {
        ProjectsService.getAll().then((res) => {
          this.projects = res.data;
          this.projectsLoaded = true;
        }).catch((err) => {
          LoggingService.log("Admin", "Error loading projects", err);
        });      
      },
      newProject() {
        if (this.editingProject) {
          this.cancelEditing();
        } else {
          this.editingProject = true;
        }
      },
      editProject(project) {
        this.editingProject = true;
        
        let projectCopy = JSON.parse(JSON.stringify(project));
        this.selectedProject = projectCopy;
      },
      deleteProject(id) {
        ProjectsService.deleteProject(id).then(() => {
          this.loadProjects();
        }).catch((err) => {
          LoggingService.log("Admin", "Error deleting project", err);
        })
      },
      cancelEditing() {
        this.editingProject = false;
        this.selectedProject = {
          title: '',
          year: '',
          description: '',
          cover: '',
          photoCredit: '',
          images: []
          };
      }
    },
    created: function () {
      this.loadProjects();
      this.loadSettings();

      const root = document.documentElement;
      root.style.setProperty('--body-bg', '#00BCD4');
      root.style.setProperty('--text-primary', '#FFFFFF');

      EventBus.$on('projectModifyEvent', () => {
        this.cancelEditing();
        this.loadProjects();
      });

    },
}
</script>

<style lang="less" scoped>
#admin-panel {
  margin-top: 150px;
  color: #ffff;
  .admin-top-bar {
    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
    z-index: 2;    
    background-color: #006471;
    width: 100%;
    top: 0;
    right: 0;
    display: flex;
    position: fixed;
    justify-content: center;
    align-items: center;
    #logout-btn {
      margin-left: auto;
      margin-right: 20px;
    }
    h1 {
      margin-left: 20px;
      margin-right: auto;
    }
  }
}
.projects-list {
  margin-top: 20px;
  max-width: 100%;
  padding: 10px;
  margin: 0 auto;
  .projects-list-item {
    background-color: #ffffff;
    color: var(--text-on-primary-bg);
    box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
    display: flex;
    margin-bottom: 10px;
    text-align: left;
    border-radius: 8px;
    margin-right: 10px;
    padding: 20px;
    p {
      font-weight: 600;
      font-size: smaller;
      margin: 0;
      padding: 5px;
    }
    .projects-list-item-actions {
      margin-left: auto;
      svg {
        cursor: pointer;
      }
      .delete-icon {
        color: crimson;
      }
      .delete-icon:hover {
        transition: all .1s ease-in-out;
        color: darken(crimson, 15%);
      }
      .edit-icon {
        color: var(--primary-text);
        margin-right: 20px;
      }
      .edit-icon:hover {
        transition: all .1s ease-in-out;
        color: darken(#343434, 15%);
      }
    }
  }
}
.fab {
  position: fixed;
  width: 56px;
  right: 45px;
  bottom: 45px;
  margin-left: -28px;
}

.fab:hover {
  .fab-action-button {
    cursor: pointer;
    box-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);
    transition: all .2s ease-out;
  }
}

.fab-action-button {
  transition: all .2s ease-out;
  position: absolute;
  bottom: 0;
  display: block;
  width: 56px;
  height: 56px;
  background-color: #e91e63;
  border-radius: 50%;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -2px rgba(0, 0, 0, 0.2);
  .material-design-icon {
    margin-top: 17px;
  }
}

.fab-buttons__item {
  display: block;
  text-align: center;
  margin: 12px 0;
}

.icon-material {
  display: inline-block;
  width: 40px;
  height: 40px;
}

/* Basic Buttons */
.btn {
  display: inline-block;
  padding: 0.6em 1.5em;
  border-radius: 2px;
  background-color: #e91e63;
  color: #fff;
  border: 0;
  outline: none;
  cursor: pointer;
  font-family: inherit;
  font-weight: 400;
  font-size: 1rem;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.24), 0 1px 2px 0 rgba(0, 0, 0, 0.12);
  transition: all 0.2s ease;
}
.btn:focus, .btn:hover {
  background-color: lighten(#e91e63, 15%);
}
</style>